import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type CommentMemberFragment = (
  { __typename: 'Member' }
  & Pick<Types.Member, 'id' | 'username'>
);

export const CommentMemberFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CommentMember' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'username' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseCommentMemberFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<CommentMemberFragment, Apollo.OperationVariables>,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseCommentMemberFragmentResult
  extends Omit<Apollo.UseFragmentResult<CommentMemberFragment>, 'data'> {
  data?: CommentMemberFragment;
}

export const useCommentMemberFragment = ({
  from,
  returnPartialData,
  ...options
}: UseCommentMemberFragmentOptions): UseCommentMemberFragmentResult => {
  const result = Apollo.useFragment<CommentMemberFragment>({
    ...options,
    fragment: CommentMemberFragmentDoc,
    fragmentName: 'CommentMember',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Fragment data is incomplete.', result);
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as CommentMemberFragment };
};
